import {useUpmPlantsContext} from '@hconnect/upm'
import {Outlet} from 'react-router'

import {usePermissionsQuery} from '../../permissions/hooks'
import {useLatestQuery} from '../hooks'
import {SettingsToursProvider} from '../providers/SettingsToursProvider'
import {isForbidden} from '../utils'

import {DefaultShell} from './DefaultShell'
import {PermissionDeniedFallback} from './PermissionDeniedFallback'
import {PageSkeleton} from './skeletons/PageSkeleton'

import {RouteName} from '@settings/modules/routing'

export const PagePlant: React.FC = () => {
  const upmPlants = useUpmPlantsContext({isInitialLoad: true})
  const {data: permissions, error: permissionsError} = usePermissionsQuery()
  const {data: latest, error: latestError} = useLatestQuery()

  if (isForbidden(permissionsError, latestError)) {
    return <PermissionDeniedFallback dataTestId={`page_${RouteName.NOT_AUTHORIZED}`} />
  }

  return permissions && latest && upmPlants ? (
    <SettingsToursProvider>
      <DefaultShell>
        <Outlet />
      </DefaultShell>
    </SettingsToursProvider>
  ) : (
    <PageSkeleton />
  )
}
